import { render, staticRenderFns } from "./XCircleIcon.vue?vue&type=template&id=10d7d466"
import script from "./XCircleIcon.vue?vue&type=script&lang=js"
export * from "./XCircleIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports